var _react_refresh_temp_1;
var _react_refresh_temp_2;
_react_refresh_temp_2 = $RefreshSig$();
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState, useEffect } from 'react';
import { Popover } from '@headlessui/react';
import { useTranslation } from 'react-i18next';
import PopoverPanelElms from './popoverPanelElms';
import { store } from '../../../store';
const SubtitleTextsHistory = ({ isOpenPopover }) => {
    _react_refresh_temp_2();
    const { t } = useTranslation();
    const [showPopover, setShowPopover] = useState(false);
    useEffect(() => {
        var _a;
        const isRecorder = (_a = store.getState().session.currentUser) === null || _a === void 0 ? void 0 : _a.isRecorder;
        if (!isRecorder) {
            setShowPopover(true);
        }
    }, []);
    useEffect(() => {
        isOpenPopover(showPopover);
    }, [showPopover]);
    return (_jsxs(Popover, { className: "subtitleTextsHistory relative", children: [_jsx("button", { className: "absolute left-[2.7rem] lg:left-[3.1rem] bottom-1", onClick: () => setShowPopover(!showPopover), children: _jsxs("div", { className: "microphone footer-icon relative h-[35px] lg:h-[40px] w-[35px] lg:w-[40px] rounded-full bg-[#F2F2F2] dark:bg-darkSecondary2 hover:bg-[#ECF4FF] flex items-center justify-center cursor-pointer has-tooltip", children: [_jsx("span", { className: "tooltip", children: t('speech-services.subtitle-history-modal-title') }), _jsx("i", { className: `pnm-timeline-solid dark:text-darkText text-[12px] lg:text-[14px] ${showPopover ? 'secondaryColor' : 'primaryColor'}` })] }) }), showPopover ? (_jsx(PopoverPanelElms, { setShowPopover: setShowPopover, showPopover: showPopover })) : null] }));
};
_react_refresh_temp_1 = SubtitleTextsHistory;
$RefreshReg$(_react_refresh_temp_1, "SubtitleTextsHistory");
_react_refresh_temp_2(SubtitleTextsHistory, "lOY/zZz5z+vIdCUQ2O+0SJVRX3E=", false, () => [useTranslation]);
export default SubtitleTextsHistory;
